import {GameView} from "./GameView";
import * as PIXI from "pixi.js";
import {BackgroundEffect} from "../effects/BackgroundEffect";
import {GameObject} from "./GameObject";
import {RectangleUtils, ScaleMode} from "../utils/RectangleUtils";
import {PixiAssetsLoader} from "../assets/PixiAssetsLoader";

export class GameScreen extends GameView {

  public assetsLoader: PixiAssetsLoader | null = null;
  
  protected _bgImage?: PIXI.Sprite | null = null;
  protected _bgParticleEffect: BackgroundEffect | null = null;
  protected _isAdded = false;

  constructor() {
    super();
    // this.interactive = true;
  }

  public getAreaForHtml(){
    return this.boundsArea;
  }

  public get screenID() {
    return "GameScreen";
  }

  override destroy() {
    super.destroy();
    this._bgImage = GameObject.destroy(this._bgImage);
    this._bgParticleEffect = GameObject.destroy(this._bgParticleEffect);
    this.assetsLoader = GameObject.destroy(this.assetsLoader);
  }

  public async onAdded() {
    this._isAdded = true;
  }

  public getStateDescription() {
    return "GameScreen: ";
  }

  public async loadAssets(onLoad?: () => void) {
    if (onLoad) {
      onLoad();
    }
  }

  public createBg() {
    this._bgImage = new PIXI.Sprite(this.getBgTexture());
    this._bgImage.interactive = false;

    const launchImageSize = RectangleUtils.fitRectangle(
      new PIXI.Rectangle(0, 0, this._bgImage!.width, this._bgImage!.height),
      new PIXI.Rectangle(0, 0, this.root.fixedStageWidth, this.root.fixedStageHeight),
      ScaleMode.NO_BORDER
    );

    this._bgImage!.width = launchImageSize.width;
    this._bgImage!.height = launchImageSize.height;
    this.addChild(this._bgImage!);
  }

  protected getBgTexture() {
    return this.assetsLoader?.getTextureByName('bg');
  }

  protected createBgEffect(): void {
    this._bgParticleEffect = new BackgroundEffect(this.root, 80);
    this.addChild(this._bgParticleEffect)
  }

  public onActivate(): void {
  }

  public onDeActivate(): void {
  }

  public onExit(): void {
  }

}
